(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.VuetaminPlugin = factory());
}(this, (function () { 'use strict';

var PROPERTY = 'vuetamin';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};





var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();





var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/**
 * Check if the options of a Vue component contain the Vuetamin
 * property.
 *
 * @param {Object} options The options property from a Vue component.
 */
var hasVuetaminOptions = function hasVuetaminOptions(options) {
  var definitions = options[PROPERTY];

  return definitions && (typeof definitions === 'undefined' ? 'undefined' : _typeof(definitions)) === 'object';
};

/**
 * Build an identifier for a component's thread method.
 *
 * @param {Number} uid The UID of the Vue component.
 * @param {String} name Name of the method.
 */
var buildKey = function buildKey(uid, name) {
  return 'vue_' + uid + '_' + name;
};

/**
 * A single thread. It stores all handlers for the given thread and provides
 * a way to add, remove and run them.
 */

var Thread = function () {
  function Thread(name) {
    classCallCheck(this, Thread);

    this.name = name;
    this.handlers = [];
  }

  /**
   * Add a handler.
   *
   * @param {Function} method The method to be added.
   * @param {String} uid The uid of the Vue component.
   * @param {Object} context The context of the Vue component.
   */


  createClass(Thread, [{
    key: 'add',
    value: function add(method, methodName, uid, context) {
      var key = buildKey(uid, methodName);

      this.handlers.push({
        key: key,
        method: method,
        context: context
      });
    }

    /**
     * Remove a handler.
     *
     * @param {Handler} handler The handler to be removed.
     * @param {String} uid The uid of the Vue component.
     */

  }, {
    key: 'remove',
    value: function remove(uid, methodName) {
      var key = buildKey(uid, methodName);

      for (var i = 0; i < this.handlers.length; i++) {
        if (this.handlers[i] !== null && this.handlers[i].key === key) {
          this.handlers[i] = null;
        }
      }
    }

    /**
     * Run all handlers in this thread.
     *
     * @param {Object} state The state object to be provided for all handlers.
     * @param {Object} history It's properties are the keys of all handlers already run.
     * 
     * @returns {Object} The altered history object.
     */

  }, {
    key: 'run',
    value: function run(state, history) {
      // Store the already called handlers.
      var currentRun = history;

      // Loop over all handlers and run them. Also make sure they are
      // not called multiple times.
      for (var i = 0; i < this.handlers.length; i++) {
        if (this.handlers[i] !== null) {
          var handler = this.handlers[i];
          if (!currentRun[handler.key]) {
            this.handlers[i].method.call(handler.context, state);
            currentRun[handler.key] = true;
          }
        }
      }

      return currentRun;
    }
  }]);
  return Thread;
}();

/**
 * Manages threads, handles adding and removing them.
 * Keeps track of the queue and tracks them.
 */

var Threads = function () {
  function Threads() {
    classCallCheck(this, Threads);

    this.threads = {};
    this.queue = {};
  }

  /**
   * Adds a thread method of a Vue component to the corresponding
   * thread. Triggers the thread for the initial render.
   *
   * @param {String} threadName Name of the thread.
   * @param {Number} uid The UID of the Vue component.
   * @param {Function} method The method to be called.
   * @param {String} methodName Name of the method in the component.
   * @param {Object} context The context ('this') of the component.
   */


  createClass(Threads, [{
    key: 'addHandler',
    value: function addHandler(threadName, uid, methodName, method, context) {
      if (!this.threads[threadName]) {
        this.threads[threadName] = new Thread(threadName);
      }

      this.threads[threadName].add(method, methodName, uid, context);
      this.trigger(threadName);
    }

    /**
     * Removes a method from a thread.
     *
     * @param {String} threadName Name of the thread.
     * @param {Number} uid The UID of the Vue component.
     * @param {String} methodName Name of the method in the component.
     */

  }, {
    key: 'removeHandler',
    value: function removeHandler(threadName, uid, methodName) {
      this.threads[threadName].remove(uid, methodName);
    }

    /**
     * Triggers a thread.
     *
     * @param {String} threadName Name of the thread.
     */

  }, {
    key: 'trigger',
    value: function trigger(threadName) {
      this.queue[threadName] = true;
    }

    /**
     * Loop over all threads and run the methods of the threads
     * that are queued. Checks that a method is only run once.
     *
     * @param {Object} state The Vuetamin state.
     */

  }, {
    key: 'step',
    value: function step(state) {
      var _this = this;

      var history = {};

      Object.keys(this.threads).forEach(function (thread) {
        if (_this.queue[thread]) {
          _this.queue[thread] = false;
          history = _this.threads[thread].run(state, history);
        }
      });
    }
  }]);
  return Threads;
}();

/**
 * Vuetamin manages the state and provides ways to mutate the state.
 */
var Store = function () {
  /**
   * @param {Object} options
   * @param {Function} triggerFn The function to trigger a thread.
   */
  function Store() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        data = _ref.data,
        state = _ref.state,
        mutations = _ref.mutations,
        actions = _ref.actions;

    var triggerFn = arguments[1];
    classCallCheck(this, Store);

    this.data = data();
    this.mutations = this.buildFromProperties(mutations);
    this.actions = this.buildFromProperties(actions);

    this._getState = state;

    // Store the context which will be passed to mutation and action methods.
    this._context = {
      data: this.data,
      trigger: triggerFn,
      mutate: this.mutate.bind(this),
      action: this.action.bind(this)
    };
  }

  /**
   * Returns the state from data by calling the user-defined
   * state function.
   * 
   * @returns {Any}
   */


  createClass(Store, [{
    key: "getState",
    value: function getState() {
      return this._getState(this.data);
    }

    /**
     * Returns the store data.
     * 
     * @returns {Object}
     */

  }, {
    key: "getData",
    value: function getData() {
      return this.data;
    }

    /**
     * Loop over the properties of an object, validate them and
     * build a new object. Used for adding actions and mutations.
     *
     * @param {Object} properties 
     */

  }, {
    key: "buildFromProperties",
    value: function buildFromProperties(properties) {
      var entries = {};

      Object.keys(properties).forEach(function (name) {
        entries[name] = properties[name];
      });

      return entries;
    }

    /**
     * Calls the mutation with the given payload and passes
     * the context to it.
     *
     * @param {String} name Name of the mutation
     * @param {Any} value Payload
     */

  }, {
    key: "mutate",
    value: function mutate(name, value) {
      this.mutations[name].call(this, this._context, value);
    }

    /**
     * Calls the action with the given payload and passes
     * the context to it.
     *
     * @param {String} name Name of the action
     * @param {Any} value Payload
     */

  }, {
    key: "action",
    value: function action(name, value) {
      this.actions[name].call(this, this._context, value);
    }
  }]);
  return Store;
}();

/**
 * The Vuetamin class handles both the threads and the store.
 * It runs the main requestAnimationFrame loop and manages
 * adding and removing Vue component's handlers.
 */

var Vuetamin = function () {
  function Vuetamin(store) {
    classCallCheck(this, Vuetamin);

    this.threads = new Threads();
    this.store = new Store(store, this.trigger.bind(this));

    this._loop();
  }

  /**
   * Main requestAnimationFrame loop. Calls the step function
   * of the threads and passes the current state.
   */


  createClass(Vuetamin, [{
    key: '_loop',
    value: function _loop() {
      var state = this.store.getState();

      this.threads.step(state);

      window.requestAnimationFrame(this._loop.bind(this));
    }

    /**
     * Loop over the defined handlers from a Vue component and for every
     * thread either remove or add the handler.
     *
     * The function expects the following structure on a component:
     *  
     * vuetamin: {
     *   methodName1: ['thread1', 'thread2'],
     *   methodName2: ['thread1', 'thread4']
     * }
     * 
     * @param {VueComponent} component A Vue component
     * @param {String} action The action to do (add or remove)
     */

  }, {
    key: '_forComponent',
    value: function _forComponent(component, action) {
      var _this = this;

      var definitions = component.$options[PROPERTY];

      Object.keys(definitions).forEach(function (methodName) {
        // Get the threads of the handler.
        var threads = function () {
          var val = definitions[methodName];

          // If it's an array, return that.
          // Strings are allowed, so return the string as an array.
          if (Array.isArray(val)) {
            return val;
          } else if (typeof val === 'string') {
            return [val];
          } else {
            throw new Error('Invalid thread definition in ' + component.$vnode.tag);
          }
        }();

        threads.forEach(function (thread) {
          var method = component[methodName];
          var uid = component._uid;

          var functionName = action === 'add' ? 'addHandler' : 'removeHandler';
          _this.threads[functionName](thread, uid, methodName, method, component);
        });
      });
    }

    /**
     * Trigger the specified thread.
     *
     * @param {String} threadName Name of the thread.
     */

  }, {
    key: 'trigger',
    value: function trigger(threadName) {
      this.threads.trigger(threadName);
    }

    /**
     * Add a Vue component to the desired threads.
     *
     * @param {VueComponent} component A Vue component.
     */

  }, {
    key: 'addComponent',
    value: function addComponent(component) {
      this._forComponent(component, 'add');
    }

    /**
     * Remove a vue component from all registered threads.
     *
     * @param {VueComponent} component A Vue component.
     */

  }, {
    key: 'removeComponent',
    value: function removeComponent(component) {
      this._forComponent(component, 'remove');
    }
  }]);
  return Vuetamin;
}();

/**
 * Install the Vuetamin plugin in the global scope and add
 * the hooks in the components to add or remove themselves.
 */
var plugin$1 = {
  // eslint-disable-next-line no-unused-vars
  install: function install(Vue) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$store = _ref.store,
        store = _ref$store === undefined ? {} : _ref$store;

    Vue.prototype.$vuetamin = new Vuetamin(store);

    Vue.mixin({
      mounted: function mounted() {
        if (hasVuetaminOptions(this.$options)) {
          this.$vuetamin.addComponent(this);
        }
      },

      beforeDestroy: function beforeDestroy() {
        if (hasVuetaminOptions(this.$options)) {
          this.$vuetamin.removeComponent(this);
        }
      }
    });
  }
};

// Auto-install
var _Vue = null;
if (typeof window !== 'undefined') {
  _Vue = window.Vue;
} else if (typeof global !== 'undefined') {
  _Vue = global.Vue;
}
if (_Vue) {
  _Vue.use(plugin$1);
}

return plugin$1;

})));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
